"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIA15 = exports.iA15UseableDef = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const ArticleBase_1 = require("../../ArticleBase");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
exports.iA15UseableDef = {
    parent: ArticleBase_1.articleBaseUseableDef,
    validation: {
        ArticleType: (v) => v === echain_product_models_1.ArticleType.ia,
    },
};
exports.isIA15 = echain_shared_modelling_1.UseableUtil.createGuard(exports.iA15UseableDef);
//# sourceMappingURL=IA15.js.map